// extracted by mini-css-extract-plugin
export default {"content":"TextArea_content__vGZ4E","label":"TextArea_label__f0K4X","textarea":"TextArea_textarea__z6Lij","textareaerror":"TextArea_textareaerror__D-+uy"};